module.exports = __webpack_public_path__ + "static/media/solelilblanc-removebg-preview.f86e2e7b.png";